export const FLOOR_MAP_IMAGE_WIDTH_MIN = 200;
export const FLOOR_MAP_IMAGE_WIDTH_MAX = 1600;
export const FLOOR_MAP_IMAGE_HEIGHT_MIN = 480;
export const FLOOR_MAP_IMAGE_HEIGHT_MAX = 960;
export const FLOOR_MAP_IMAGE_HEIGHT_VIEWPORT_RATIO = 0.45;
export const FLOOR_MAP_ZOOM_MIN = 0.5;
export const FLOOR_MAP_ZOOM_MAX = 3;
export const FLOOR_MAP_ZOOM_STEP = 0.1;
export const FLOOR_MAP_ICON_RATIO_DEFAULT = 1;

export const getFloorMapImageHeightMax = (viewportHeight: number): number =>
  Math.round(
    Math.min(
      FLOOR_MAP_IMAGE_HEIGHT_MAX,
      Math.max(FLOOR_MAP_IMAGE_HEIGHT_MIN, viewportHeight * FLOOR_MAP_IMAGE_HEIGHT_VIEWPORT_RATIO)
    )
  );

export const fitFloorMapImageWidth = (
  containerWidth: number,
  aspectRatio = 0,
  imageHeightMax = FLOOR_MAP_IMAGE_HEIGHT_MIN
): number =>
  Math.round(
    Math.min(
      FLOOR_MAP_IMAGE_WIDTH_MAX,
      Math.max(
        FLOOR_MAP_IMAGE_WIDTH_MIN,
        Math.min(containerWidth, aspectRatio > 0 ? imageHeightMax / aspectRatio : containerWidth)
      )
    )
  );

/**
 * フロアマップ上の端末アイコンの表示サイズを計算する。
 *
 * アイコン倍率はフロア登録画面と同じく、表示画像の長辺に対する比率
 *（iconRatio / 50）で扱う。呼び出し側は現在表示している画像の幅・高さを渡す
 * ことで、画像のズームにアイコンも追従させる。
 * 不正な倍率は登録時の既定値に戻す。
 */
export const getFloorMapIconSize = (
  containerWidth: number,
  containerHeight: number,
  iconRatio: number
): number => {
  const safeWidth = Number.isFinite(containerWidth) && containerWidth > 0 ? containerWidth : 0;
  const safeHeight = Number.isFinite(containerHeight) && containerHeight > 0 ? containerHeight : 0;
  const safeRatio =
    Number.isFinite(iconRatio) && iconRatio > 0 ? iconRatio : FLOOR_MAP_ICON_RATIO_DEFAULT;
  const referenceSize = Math.max(safeWidth, safeHeight);

  if (referenceSize === 0) return 0;

  return Math.round(referenceSize * (safeRatio / 50));
};
